import React, { useContext, useRef, useState } from 'react'
import DeepDiveOpenButton from './DeepDive/DeepDiveOpenButton';
import { VideoContext } from '../context/VideoContext';
import { Positions, Sizes } from '../constants/index';

const Overlay = ({ children, position, size, deepdiveIndex, deepdive="", index, disclaimer }) => {
  
  const { overlays, setCurrentDeepDiveIndex, deepDiveButtonRefs } = useContext(VideoContext);
  const where = Positions.find((pos) => pos.type === position);
  const width = Sizes.find((w) => w.type === size);

  // sets VideoContext currentDeepDiveIndex to the index of the Deep Dive to open, DeepDives.js reacts to that global state change
  const openDeepDive = (index) => {
    setCurrentDeepDiveIndex(index);
  }

  return (
    <div
      className={`overlay-container opacity-100 flex flex-row min-h-full px-6 ${overlays.deepdive ? "py-32" : "py-16"} md:px-12 md:py-28 text-center items-end ${where.className}`}
    >
      <div className={`overlayContainer flex flex-col ${(position.indexOf("Left") === -1) ? "items-end" : "items-start"} ${deepdive !== "" && "-mb-3 md:-mb-12"}`}>
      {
        (disclaimer && disclaimer === true) && <div className="md:fixed md:bottom-3 mobile:mb-5 mobile:mr-[-.75rem] md:right-4 text-white text-[12px] italic">animated images</div>
      }
        <div
          className={`!block overlay ${width.className} text-[20px] md:text-[22px] leading-[23px] md:leading-[25px] transform p-4 text-white align-middle bg-black bg-opacity-70 outline-double border-double outline-offset-[10px] outline-neon outline-[1px] border-[1px] border-neon shadow-overlay font-light z-10`}
        >
          <span className="corner w-[25px] h-[25px]  translate-y-[-1px] translate-x-[-1px] TL absolute bg-[url('./img/corner.svg')] -top-[15px] -left-[15px]"></span>
          <span className="corner w-[25px] h-[25px] translate-y-[-2px] TR absolute bg-[url('./img/corner.svg')] -top-[14px] -right-[16px] rotate-90"></span>
          <span className="corner  w-[25px] h-[25px] translate-y-[2px] BL absolute bg-[url('./img/corner.svg')] -bottom-[14px] -right-[16px] rotate-180"></span>
          <span className="corner w-[25px] h-[25px] translate-y-[1px] translate-x-[1px] BR absolute bg-[url('./img/corner.svg')] -bottom-[15.5px] -left-[17px] -rotate-90"></span>
          
          {children}
          
        </div>

        {deepdive !== "" && (
          <>
            <DeepDiveOpenButton 
              ref={(el) => (deepDiveButtonRefs.current[index] = el)} 
              className={`!block !opacity-100 !relative !bottom-0 !mt-6`}
              isOpen={true}
              onClick={() => {openDeepDive(deepdiveIndex)}}
            >
              {deepdive}
            </DeepDiveOpenButton>
          </>
        )}

      </div>

    </div>
  );
};

export default Overlay;